import React, {useEffect} from 'react';
import {useImageEditorContext} from "../../../../../../../../../../context/ImageEditorProvider";
import './ImageEditor.scss'

const ImageEditor = () => {
  const {canvasRef, init,} = useImageEditorContext();

  useEffect(() => {
    if (canvasRef.current) {
      init({forceInit: true})
    }
  }, [canvasRef, init]);

  return (
    <div className='image-editor'>
      <div className='image-editor__content'>
        <canvas ref={canvasRef} id='canvas-ref-here'/>
      </div>
    </div>
  );
};

export default ImageEditor;
